import React from 'react'
import AlumniDash from '../../Components/AlumniComponent/AlumniDash/AlumniDash'
import FeedbackForm from '../../Components/Feedback/FeedbackForm'

function FeedbackPageA() {
  return (
    <AlumniDash>
        <FeedbackForm/>
    </AlumniDash>
  )
}

export default FeedbackPageA